import { render, staticRenderFns } from "./HistogramCharts.vue?vue&type=template&id=436076be&scoped=true"
import script from "./HistogramCharts.vue?vue&type=script&lang=js"
export * from "./HistogramCharts.vue?vue&type=script&lang=js"
import style0 from "./HistogramCharts.vue?vue&type=style&index=0&id=436076be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436076be",
  null
  
)

export default component.exports